window.Flux || (window.Flux = {});